<template>
  <div>
    <div class="text-center" v-if="LoadingSpiner">
      <div class="loader-container">
        <div class="item-1"></div>
        <div class="item-2"></div>
        <div class="item-3"></div>
        <div class="item-4"></div>
        <div class="item-5"></div>
      </div>
    </div>
    <div class="main-container" v-if="main">
      <header class="d-md-flex d-sm-block header-background-e ">
        <div class="col-md-3 col-sm-12 header-background-color header-background text-center pt-sm-5 pb-sm-5">
          <img src="../assets/img/logo-wh.svg" width="170" class=" d-sm-block d-md-none sm-img ">
        </div>
        <div class="col-md-9 col-sm-12 d-flex p-4">
             <template v-if="isgeo === 1">
                   <img src="../assets/img/ardi-logo.svg" width="170" class="d-md-block d-sm-none extra">
              </template>
              <template v-else>
                  <img src="../assets/img/logoEn1.svg" width="170" class="d-md-block d-sm-none extra">
              </template>
          <div class="ml-md-5 nino-mtavruli font-weight-bold mt-3 col-md-7 header-text"> 
           {{$t('3000geltext')}}
            <!--ვინაიდან თქვენს მიერ
            მისაღები
            სადაზღვევო
            პოლისის წლიური პრემია აღემატება 3,000 ლარს,
            გთხოვთ გვიპასუხოთ რამდენიმე დამატებით შეკითხვაზე,
            რაც სავალდებულოა საქართველოს კანონმდებლობით-->
          </div>
        </div>
      </header>
      <main>
        <b-container>
          <b-col cols="10" offset="1" class="pt-3">
            <b-row>

              <!--Personal Info-->
              <b-col cols="12" class="mt-3 p-2 content-header ">
                  <div class="col-md-9 offset-md-3 text-center nino-mtavruli">{{$t('policyholder')}}</div>
              </b-col>
              <b-col md="3" sm="12" class="description-in-form p-2 value-border-top">
                  {{$t('usernamesurname')}}
              </b-col>
              <input type="text" class="col-md-9 col-sm-12 p-2" v-model.trim="form.fullName" :class="{validation:$v.form.fullName.$error 
                                  && !$v.form.fullName.required}"/>

              <b-col md="3" sm="12" class="description-in-form p-2 value-border-top">
                  {{$t('idnumber')}}
              </b-col>
              <input type="text" class="col-md-9 col-sm-12 p-2" v-model.trim="form.personalID" :class="{validation:$v.form.personalID.$error 
                                  && !$v.form.personalID.required}"/>

              <b-col md="3" sm="12" class="description-in-form p-2 value-border-top">
                  {{$t('bday')}}
              </b-col>
              <input type="text" class="col-md-2 col-sm-12 p-2" v-model.trim="form.dataOfBirth" :class="{validation:$v.form.dataOfBirth.$error 
                                  && !$v.form.dataOfBirth.required}"/>
              <b-col md="2" sm="12" class="description-in-form p-2 ">{{$t('birthplace')}}</b-col>
              <input type="text" class="col-md-5 col-sm-12 p-2" :class="{validation:$v.form.placeOfBirth.$error 
                                  && !$v.form.placeOfBirth.required}" v-model="form.placeOfBirth"/>

              <b-col md="3" sm="12" class="p-0 row d-md-flex d-none">
                <b-col md="6" sm="12" class=" description-in-form value-border-top">
                    <div class="vertical-center"> {{$t('address')}}</div>
                </b-col>
                <div class="col-md-6 col-sm-12   p-0">
                  <div class="row">
                      <div class="col-md-12 col-sm-3 value-border-top value-border-left description-in-form text-center p-2">
                          {{$t('registered')}}
                      </div>
                      <div class="col-md-12 col-sm-6 value-border-top value-border-left description-in-form text-center p-2">
                          {{$t('actual')}}
                      </div>
                  </div>
                </div>
              </b-col>


              <div class="col-9  p-0 d-md-block d-none">
                <input type="text" class="col-12 p-2" :class="{validation:$v.form.address.legal.$error 
                                  &&!$v.form.address.legal.required}" v-model.trim="form.address.legal"/>
                <input type="text" class="col-12 p-2" v-model.trim="form.address.actual" :class="{validation:$v.form.address.actual.$error 
                                  && !$v.form.address.actual.required}"/>

              </div>

              <b-col md="3" sm="12" class="description-in-form p-2 value-border-top d-md-none d-block">
                  {{$t('registered')}}
              </b-col>
              <input type="text" class="col-md-9 col-sm-12 d-md-none d-block p-2"
                     v-model.trim="form.address.legal" :class="{validation:$v.form.address.legal.$error 
                                  &&!$v.form.address.legal.required}"/>

              <b-col md="3" sm="12" class="description-in-form p-2 value-border-top d-md-none d-block">
                  {{$t('actual')}}
              </b-col>
              <input type="text" class="col-md-9 col-sm-12 d-md-none d-block p-2"
                     v-model.trim="form.address.actual" :class="{validation:$v.form.address.actual.$error 
                                  && !$v.form.address.actual.required}"/>


              <b-col md="3" sm="12" class="description-in-form p-2 value-border-top">
                  {{$t('mobemail')}}
              </b-col>
              <input type="text" class="col-md-9 col-sm-12 p-2" v-model.trim="form.contactInfo" :class="{validation:$v.form.contactInfo.$error 
                                  && !$v.form.contactInfo.required}"/>
              <b-col md="3" sm="12" class="description-in-form p-2 value-border-top">
                  {{$t('mainwork')}}
              </b-col>
              <input type="text" class="col-md-9 col-sm-12 p-2"
                     v-model.trim="form.activitiesAndPositionsHeld" :class="{validation:$v.form.activitiesAndPositionsHeld.$error 
                                  && !$v.form.activitiesAndPositionsHeld.required}"/>

              <b-col md="3" sm="12" class="description-in-form p-2 value-border-top">
                  {{$t('amountsource')}}
              </b-col>
              <input type="text" class="col-md-9 col-sm-12 p-2"
                     v-b-popover.hover.top="$t('thesourceofmoney')"
                     v-model.trim="form.SourceOfMoney" :class="{validation:$v.form.SourceOfMoney.$error 
                                  && !$v.form.SourceOfMoney.required}"/>

              <b-col md="3" sm="12" class="description-in-form p-2 value-border-top">
                  {{$t('citizenshipduo')}}
              </b-col>
              <input type="text" class="col-md-9 col-sm-12 p-2" v-model.trim="form.citizenship" :class="{validation:$v.form.citizenship.$error 
                                  && !$v.form.citizenship.required}"/>

              <b-col cols="12" class="mt-3 p-2 content-header ">
                  <div class="col-md-9 offset-md-3 text-center nino-mtavruli">
                      {{$t('politicalperson')}}
                      <b-icon icon="info-circle" class="ml-2"
                              v-b-popover.hover.bottom="$t('politicallyactivedefinition')" />
                  </div>
              </b-col>
              <b-col md="3" sm="12" class="description-in-form p-2 value-border-top">
                  {{$t('areyoupolitically')}}
              </b-col>
              <b-form-select :options="options" v-model.trim="form.politicallyActive"
                             class="col-md-9 col-sm-12 p-2" :class="{validation:$v.form.politicallyActive.$error 
                                  && !$v.form.politicallyActive.required}"></b-form-select>

              <template v-if="form.politicallyActive">
                  <b-col md="3" sm="12" class="description-in-form p-2 value-border-top">
                      {{$t('politicallyyear')}}
                  </b-col>
                <input type="text" class="col-md-9 col-sm-12 p-2" v-model="form.positionAndPeriod"/>
              </template>
              <b-col md="3" sm="12" class="description-in-form p-2 value-border-top mt-2">
                  {{$t('politicallyyfamily')}}
              </b-col>
              <b-form-select :options="options"
                             v-model.trim="form.politicallyActiveFamilyMember.isPoliticallyActiveFamilyMember"
                             class="col-md-9 col-sm-12 mt-md-2 mt-sm-0 p-2" :class="{validation:$v.form.politicallyActiveFamilyMember.isPoliticallyActiveFamilyMember.$error 
                                  && !$v.form.politicallyActiveFamilyMember.isPoliticallyActiveFamilyMember.required}"></b-form-select>

              <template v-if="form.politicallyActiveFamilyMember.isPoliticallyActiveFamilyMember===true">
                <b-col md="3" sm="12" class="row p-0">
                  <b-col cols="1" class="description-in-form p-2 value-border-top">1</b-col>
                  <b-col cols="11" class="question-border p-2">
                      {{$t('politicallyyname')}}
                  </b-col>
                </b-col>
                <input type="text" class="col-md-9 col-sm-12 p-2"
                       v-model="form.politicallyActiveFamilyMember.politicallyActivePersonName"/>

                <b-col md="3" sm="12" class="row p-0">
                  <b-col cols="1" class="description-in-form p-2 value-border-top">2</b-col>
                  <b-col cols="11" class="question-border p-2">
                      {{$t('politicallyyear')}}
                  </b-col>
                </b-col>
                <input type="text" class="col-md-9 col-sm-12 p-2"
                       v-model="form.politicallyActiveFamilyMember.politicallyActivePersonPosition"/>

                <b-col md="3" sm="12" class="row p-0">
                  <b-col cols="1" class="description-in-form p-2 value-border-top">3</b-col>
                  <b-col cols="11" class="question-border p-2">{{$t('relativeconnect')}}</b-col>
                </b-col>
                <input type="text" class="col-md-9 col-sm-12 p-2"
                       v-model="form.politicallyActiveFamilyMember.kinship"/>
              </template>
              <b-col md="3" sm="12" class="description-in-form p-2 value-border-top mt-2">
                  {{$t('relationshipwithpoliticallyactiveperson')}}
              </b-col>
              <b-form-select :options="options"
                             v-model.trim="form.relationshipWithPoliticallyActivePerson.isRelationshipWithPoliticallyActivePerson"
                             class="col-md-9 col-sm-12 mt-md-2 mt-sm-0 p-2 text-center" :class="{validation:$v.form.relationshipWithPoliticallyActivePerson.isRelationshipWithPoliticallyActivePerson.$error
                                   && !$v.form.relationshipWithPoliticallyActivePerson.isRelationshipWithPoliticallyActivePerson.required}"></b-form-select>

              <template
                  v-if="form.relationshipWithPoliticallyActivePerson.isRelationshipWithPoliticallyActivePerson===true">
                <b-col md="3" sm="12" class="row p-0">
                  <b-col cols="1" class="description-in-form p-2 value-border-top">1</b-col>
                  <b-col cols="11" class="question-border p-2">
                      {{$t('politicalpersonname')}}
                  </b-col>
                </b-col>
                <input type="text" class="col-md-9 col-sm-12 p-2"
                       v-model="form.relationshipWithPoliticallyActivePerson.politicallyActivePersonName"/>

                <b-col md="3" sm="12" class="row p-0">
                  <b-col cols="1" class="description-in-form p-2 value-border-top">2</b-col>
                  <b-col cols="11" class="question-border p-2">{{$t('politicallyyear')}}</b-col>
                </b-col>
                <input type="text" class="col-md-9 col-sm-12 p-2"
                       v-model="form.relationshipWithPoliticallyActivePerson.politicallyActivePersonPosition"/>
              </template>
              <b-col md="3" sm="12" class="description-in-form p-2 value-border-top mt-2">
                  {{$t('politicalbusines')}}
              </b-col>
              <b-form-select :options="options"
                             v-model.trim="form.workWithPoliticallyActivePerson.isWorkWithPoliticallyActivePerson"
                             class="col-md-9 col-sm-12 mt-md-2 mt-sm-0 p-2" :class="{validation:$v.form.workWithPoliticallyActivePerson.isWorkWithPoliticallyActivePerson.$error 
                                  && !$v.form.workWithPoliticallyActivePerson.isWorkWithPoliticallyActivePerson.required}"></b-form-select>
              <template
                  v-if="form.workWithPoliticallyActivePerson.isWorkWithPoliticallyActivePerson===true">
                <b-col md="3" sm="12" class="row p-0">
                  <b-col cols="1" class="description-in-form p-2 value-border-top">1</b-col>
                  <b-col cols="11" class="question-border p-2">
                      {{$t('organization')}}
                  </b-col>
                </b-col>
                <input type="text" class="col-md-9 col-sm-12 p-2"
                       v-model="form.workWithPoliticallyActivePerson.organizationName"/>

                <b-col md="3" sm="12" class="row p-0">
                  <b-col cols="1" class="description-in-form p-2 value-border-top">2</b-col>
                  <b-col cols="11" class="question-border p-2">{{$t('businessrelationship')}}</b-col>
                </b-col>
                <input type="text" class="col-md-9 col-sm-12 p-2"
                       v-model="form.workWithPoliticallyActivePerson.businessRelationship"/>
              </template>

              <b-col cols="12" class="description-in-form mt-2 p-2 rounded">
                  {{$t('personaldataprotected')}}
              </b-col>
              <b-button class="col-12 mt-3 mb-4 submit-btn" @click="trigger">
                  {{$t('iconfirm')}}
              </b-button>

            </b-row>
          </b-col>
        </b-container>
      </main>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import Vuelidate from "vuelidate"
import {required} from "vuelidate/lib/validators"

Vue.use(Vuelidate);


Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
  name: "MonitoringForm",
  props: ['data'],
  components: {},
  data() {
      return {
      cust: this.$route.params.cust,
      options: [
        {value: true, text: this.$t('yes')},
        {value: false, text: this.$t('no')}
      ],
      LoadingSpiner: false,
      monitoring: null,
      main: true,
      form: {
        policy: this.data.policyInfo[0].POLICYPRODUCT,
        polid: this.data.policyInfo[0].cont,
        fullName: '',
        personalID: '',
        dataOfBirth: '',
        placeOfBirth: '',
        address: {
          legal: '',
          actual: ''
        },
        contactInfo: '',
        activitiesAndPositionsHeld: '',
        SourceOfMoney: '',
        citizenship: '',
        politicallyActive: null,
        positionAndPeriod: '',
        politicallyActiveFamilyMember: {
          isPoliticallyActiveFamilyMember: null,
          politicallyActivePersonName: '',
          politicallyActivePersonPosition: '',
          kinship: ''
        },
        relationshipWithPoliticallyActivePerson: {
          isRelationshipWithPoliticallyActivePerson: null,
          politicallyActivePersonName: '',
          politicallyActivePersonPosition: ''
        },
        workWithPoliticallyActivePerson: {
          isWorkWithPoliticallyActivePerson: null,
          organizationName: '',
          businessRelationship: ''
        }
      }
    }
  },
  validations: {
    form: {
      fullName: {required},
      personalID: {required},
      dataOfBirth: {required},
      placeOfBirth: {required},
      address: {
        legal: {required},
        actual: {required},
      },
      contactInfo: {required},
      activitiesAndPositionsHeld: {required},
      SourceOfMoney: {required},
      citizenship: {required},
      politicallyActive: {required},
      politicallyActiveFamilyMember: {
        isPoliticallyActiveFamilyMember: {required},
      },
      relationshipWithPoliticallyActivePerson: {
        isRelationshipWithPoliticallyActivePerson: {required},
      },
      workWithPoliticallyActivePerson: {
        isWorkWithPoliticallyActivePerson: {required},
      }
    }
  },
  mounted() {
    this.form.address.legal = this.data.policyInfo[0].CUSTOMERREGISTRATIONADDRESS;
    this.form.fullName = this.data.policyInfo[0].CUSTOMERNAME;
    this.form.personalID = this.data.policyInfo[0].CUSTOMERSOCCARD;
    this.form.dataOfBirth = this.data.policyInfo[0].CUSTOMEBIRTHDATE;
    this.form.contactInfo = this.data.policyInfo[0].CUSTOMERPHONENUMBER + ', ' + this.data.policyInfo[0].CUST_MAIL;

  },
  methods: {
    trigger() {
      if (this.validate()) {
        this.main = false

        this.$http.post('/policy/SaveObject', {data: this.form}).then((r) => {
          if (r.data) {
            this.$emit('updateParent', 0);
            this.$http.get(`/policy/monitoring/${this.form.policy}/${this.form.polid}/${this.cust}/auto`)
                .then((r) => {
                }).catch((e) => {
              console.log(e)
            })
          }
        }).catch((e) => {
          console.log(e)
        })
      }
    },
    onUpdate(newData) {

      this.monitoring = newData
    },
    validate() {
      this.$v.$touch();
      let isValid = !this.$v.$invalid;
      console.log(isValid);
      console.log(this.$v);

      return isValid;
    },
  },
  watch: {
    monitoring() {
      this.$emit('updateParent', this.monitoring);
    }
  },
}
</script>

<style scoped>

@import "~bpg-nino-mtavruli";

.nino-mtavruli {
  font-family: "BPG Nino Mtavruli", sans-serif;
}

.submit {
  position: absolute;
  bottom: 0;
  z-index: 99999;
}


.main-container {
  background-color: #fafafa !important;
}

/*.custom-select {
    text-align-last: center;
}*/

.header-background-e {
  background-color: #eee;
}

header {
  font-size: 14px;
  color: #007960;
}

.header-text {
  font-size: 1rem;
}

.header-background-color {
  background-color: #007960;
}

.header-background {
  background: url("../assets/img/ardi-multi-logo.svg") no-repeat center;
  background-size: cover;
}

.container {
  background-color: #fff;
}

.policy-number-background {
  background-color: #00A788;
  color: #fff;
}

.popover {
  max-width: 50%;
}

.content-header {
  background-color: #005745;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}

.content-header-text {
  transform: translateX(50%);
}

.description-in-form {
  background-color: #007961;
  color: #fff;
  font-size: 12px;
}

.value-background {
  background-color: #fafafa !important;
  border: 1px solid #EEEEEE;
  font-size: 12px;
}

.question-border {
  border: 1px solid #EEEEEE;
  background-color: #fafafa;
}

.value-border-top {
  border-top: 2px solid #00A788;
}

.value-border-left {
  border-left: 2px solid #00A788;
}

/*.value-text {
    transform: translateX(33%);
}*/


table {
  width: 100%;
  font-size: 12px;
}

div {
  font-size: 12px;
}

th, td {
  border: 1px solid;
  border-collapse: collapse;

}

.row {
  margin: 0;

}

input {
  /*border: 0;*/
  background-color: #fafafa;
  border: 1px solid #EEEEEE;
  padding: 0 10px;
  /*border-bottom: 1px  solid #3E4643;*/

}

input[type="text"]:focus, select:focus {
  border-color: #00A788;
  box-shadow: 0 1px 1px #007a63 inset, 0 0 1px #00A788;
  outline: 0 none;
}

.validation {
  border: 1px solid #f64c4c;
}

.description {
  background: #007a63;
  color: #fafafa;
  border: 1px solid #7b7474;
}

.input-value {
  border: 1px solid #7b7474;
  line-height: 24px;
}

.form-control {
  /* height: auto !important;
   padding: 0 !important;*/
}

.custom-select {
  height: auto !important;
  padding: 0 !important;
  background-color: #fafafa;
  border-radius: 0;
  /*text-align-last: center;*/
  text-indent: 48%;
}


select > option:focus {
  background-color: #00A788;
  /*text-align: center;*/
}

.font-size-8pt {
  font-size: 8pt;
}


</style>